import { useMutation, useQueryClient } from '@tanstack/react-query';
import { asyncTasksQueryKeys, retryAsyncTask } from '@api/asyncTasks';
import { ApiError } from '@api/client';
import { toast } from '@/hooks/use-toast';
import { useTranslation } from './useTranslation';

export function useRetryAsyncTask() {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: (id: number) => retryAsyncTask(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: asyncTasksQueryKeys.all });
    },
    onError: (error) => {
      const description =
        error instanceof ApiError && error.status < 500
          ? error.message
          : t('job_card.retry_toast_error');

      toast({
        description,
        variant: 'destructive',
      });
    },
  });
}
